import type { ProjectVspId, ProjectWellVsp, VspId } from '@core/core/types'
import type { PayloadAction } from '@reduxjs/toolkit'
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit'
import type { WellId } from 'common/types'

export const vspAdapter = createEntityAdapter<ProjectWellVsp>({
  selectId: projectVsp => projectVsp.wellId,
})

const initialState = vspAdapter.getInitialState()

export const vspSlice = createSlice({
  name: 'vsp',
  initialState,
  reducers: {
    addWellsVspToProject(state, { payload }: PayloadAction<ProjectWellVsp[]>) {
      vspAdapter.upsertMany(state, payload)
    },
    updateOffsetVsp(
      state,
      {
        payload: { wellId, vspId, offset },
      }: PayloadAction<{ wellId: WellId; vspId: ProjectVspId; offset: string }>,
    ) {
      const wellVsp = state.entities[wellId]
      if (wellVsp) {
        const vsp = wellVsp.vspList.find(vsp => vsp.id === vspId)
        if (vsp) {
          vsp.offset = offset
        }
      }
    },
    activateVsp(
      state,
      { payload: { vspId, wellId } }: PayloadAction<{ wellId: WellId; vspId: VspId }>,
    ) {
      const wellVsp = state.entities[wellId]
      if (wellVsp) {
        const vsp = wellVsp.vspList.find(vsp => vsp.vspId === vspId)
        const activeVsp = wellVsp.vspList.find(vsp => vsp.isActive)

        if (vsp) {
          vsp.isActive = true
          if (activeVsp) {
            activeVsp.isActive = false
          }
        }
      }
    },
  },
})

export default vspSlice.reducer
